import type { FC } from 'react';

import type { RosterLevelType } from '@wwe-portal/entities/roster.type';
import { SelectableRosterStar } from '@wwe-portal/ui/features/roster';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { OfferItem as OfferItemType } from '../type';

const sixStarVariant: Record<number, 'B' | 'S' | 'G'> = {
  0: 'B',
  1: 'S',
  2: 'G',
};

export const verifyPosterString = (input: string) => {
  const regex = /^Poster_\d{2,}[GSB]$/;
  return regex.test(input);
};

export const parseStarRate = (offerType: string) => {
  const slug = parseInt(offerType.split(':')[1] ?? '', 0);

  if (slug > 18 || slug < 1 || isNaN(slug)) return null;

  const level = sixStarVariant[(slug - 1) % 3];
  const rate = Math.floor((slug - 1) / 3) + 1;
  return {
    level,
    rate,
  };
};

export const StarRarity: FC<{
  item: OfferItemType;
}> = ({ item }) => {
  const starRate = parseStarRate(item.offerType || '');

  return verifyPosterString(item.offerType || '') && starRate ? (
    <SelectableRosterStar
      className="absolute bottom-0 left-0 right-0 flex h-3 justify-center gap-0"
      hollowStar={0}
      isStoreRevamp
      level={starRate.level as RosterLevelType}
      maxRate={starRate.rate}
      rate={starRate.rate}
      starClassName={cn('', {
        'size-[11px]': starRate.rate === 1 || starRate.rate === 2,
        'size-[9px]': starRate.rate === 3 || starRate.rate === 4,
        'size-[8px]': starRate.rate === 5,
        'size-[18px]': starRate.rate === 6,
      })}
    />
  ) : null;
};
